<template>
  <el-form ref="form"
           :model="form"
           :rules="formRules"
           size="medium"
           label-width="140px"
           @submit.native.prevent="onSubmit()">
    <div class="re-el-form__flex">
      <div>
        <el-form-item label="管理员">
          <el-input v-model="form.name"
                    disabled></el-input>
        </el-form-item>
        <el-form-item label="分配规则">
          <el-select v-model="rule"
                     placeholder="请选择">
            <el-option
              v-for="item in options.rules"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择省"
                      v-if="rule === 2">
          <el-select v-model="provinceId"
                     placeholder="请选择"
                     @change="onChangeProvince">
            <el-option
              v-for="item in options.province"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="cityId"
                     placeholder="请选择"
                     v-if="rule === 2"
                     @change="onChangeCity">
                <span v-for="province in options.province"
                      v-if="province.value === provinceId">
                <el-option
                  v-for="item in province.children"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </span>
          </el-select>
          <el-button type="primary"
                     size="mini"
                     @click="onAddResource">添加
          </el-button>
        </el-form-item>
        <el-form-item label="选择区域"
                      v-if="rule === 2">
          <div v-for="(province,index) in form.provinces">
            <el-col :span="20">
              <el-input type="text"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.provinces[index].label"
                        disabled>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button type="danger"
                         icon="el-icon-delete"
                         @click="onDeleteResource(index)"></el-button>
            </el-col>
          </div>

        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { formRules } from '../platform-user-province.rules.js'

export default {
  props: {
    userid: {
      type: [Number, String],
      default: null
    },
    callbackAfterUpdate: {
      type: Function,
      default: () => {}
    }
  },
  components: {},
  data () {
    return {
      formRules,
      provinceId: null,
      cityId: null,
      provinceName: null,
      cityName: null,
      rule: null,
      form: {
        id: this.userid,
        name: null,
        provinceid: null,
        provinces: [],
      },
      options: {
        rules: [
          {label: '全国', value: -1},
          {label: '按省市分配', value: 2},
          {label: '未分配', value: 0},
        ],
        province: [],
      },
    }
  },
  computed: {},
  watch: {
    userid (newVal) {
      if (newVal > 0) {
        this.setForm(newVal)
      }
    }
  },
  created () {
    if (this.userid > 0) {
      this.setForm(this.userid)
    }
  },
  mounted () {},
  methods: {
    setForm (id) {
      request.all.common([
        request('getProvinceList'),
        request('getPlatformUsersProvince', id),
      ]).then(([province, form]) => {
        (({data}) => {
          for (let i = 0; i < data.length; i++) {
            this.options.province.push({value: data[i].id, label: data[i].name, type: data[i].type, children: []})
          }
        })(province);
        (({data}) => {
          filter.setLoop(this.form, data)
          if (data.provinceid === '') {
            this.rule = 0
          } else if (parseInt(data.provinceid) === -1) {
            this.rule = -1
          } else {
            this.rule = 2
          }
          this.form.provinces = data.strProvinceIds
        })(form)
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.provinceid = this.rule
          if (this.rule === 0) {
            this.form.provinceid = ''
          }
          if (this.rule === 2 && this.form.provinces.length <= 0) {
            this.form.provinceid = ''
          }

          this.update(this.id)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    update (id) {
      request.common('updatePlatformUserProvince', {id, ...this.form}).then((res) => {
        this.callbackAfterUpdate()
      })
    },
    onChangeProvince (value) {
      this.cityId = ''
      this.cityName = ''
      for (let i = 0; i < this.options.province.length; i++) {
        if (this.options.province[i].value === value) {
          this.provinceName = this.options.province[i].label
          if (this.options.province[i].children.length > 0) {
            return false
          } else {
            request.common('getCityList', value).then(({data}) => {
              for (let n = 0; n < data.length; n++) {
                this.options.province[i].children.push({value: data[n].id, label: data[n].name, type: data[n].type})
              }
              return true
            })
          }
        }
      }
    },
    onChangeCity (value) {
      this.cityId = value
      for (let i = 0; i < this.options.province.length; i++) {
        if (this.options.province[i].value === this.provinceId) {
          for (let n = 0; n < this.options.province[i].children.length; n++) {
            if (this.options.province[i].children[n].value === value) {
              this.cityName = this.options.province[i].children[n].label
            }
          }
        }
      }
    },
    onAddResource () {
      if (!this.provinceId) {
        return false
      }
      this.getResourceName()
    },
    onDeleteResource (index) {
      this.form.provinces.splice(index, 1)
    },
    getResourceName () {
      if (this.cityId) {
        for (let i = 0; i < this.form.provinces.length; i++) {
          if (parseInt(this.form.provinces[i].value) === parseInt(this.cityId)) {
            this.$confirm('已添加' + this.provinceName + '/' + this.cityName + '，请勿重复添加')
            return false
          }
          if (parseInt(this.form.provinces[i].value) === parseInt(this.provinceId)) {
            this.$confirm('已添加省' + this.provinceName + ',添加市失败' + this.cityName)
            return false
          }
        }

        this.form.provinces.push({
          label: this.provinceName + '/' + this.cityName,
          value: this.cityId,
          provinceId: this.provinceId,
          type: 1,
        })
      } else {
        let message = ''
        for (let n = 0; n < this.form.provinces.length; n++) {
          if (parseInt(this.form.provinces[n].provinceId) === parseInt(this.provinceId)) {
            if (parseInt(this.form.provinces[n].type) === 0) {
              this.$confirm('已添加' + this.provinceName + '，请勿重复添加')
              return false
            } else {
              message += this.form.provinces[n].label + ','
              this.form.provinces.splice(n, 1)
            }
          }
        }
        this.form.provinces.push({
          label: this.provinceName,
          value: this.provinceId,
          provinceId: this.provinceId,
          type: 0,
        })
        if (message) {
          this.$confirm('由于添加' + this.provinceName + ',删除' + message)
        }
      }
      this.provinceId = null
      this.cityId = null
      this.provinceName = null
      this.cityName = null
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/platform-user-province/components/userResourceLimitForm.vue